import { render, staticRenderFns } from "./CardOrderInitializedModal.vue?vue&type=template&id=768be3c0"
import script from "./CardOrderInitializedModal.vue?vue&type=script&lang=js"
export * from "./CardOrderInitializedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports